import React from 'react';
import { connect } from 'react-redux';
import TutorialStep1 from './TutorialStep1';
import TutorialStep2 from './TutorialStep2';
import TutorialStep3 from './TutorialStep3';
import TutorialStep4 from './TutorialStep4';
import TutorialStep5 from './TutorialStep5';
import TutorialStep6 from './TutorialStep6';
import TutorialStep7 from './TutorialStep7';
import TutorialStep8 from './TutorialStep8';
import TutorialStep9 from './TutorialStep9';

const mapStateToProps = (state) => {
  return {
    tutorialState: state.tutorialState
  };
};

const connectedTutorialManager = ({tutorialState}) => {
  if (!tutorialState.showTutorial || tutorialState.tutorialFinished) {
    return null;
  }

  let step = null;

  switch (tutorialState.stepNumber) {
    case 1:
      step = (<TutorialStep1/>);
      break;

    case 2:
      step = (<TutorialStep2/>);
      break;

    case 3:
      step = (<TutorialStep3/>);
      break;

    case 4:
      step = (<TutorialStep4/>);
      break;

    case 5:
      step = (<TutorialStep5/>);
      break;

    case 6:
      step = (<TutorialStep6/>);
      break;

    case 7:
      step = (<TutorialStep7/>);
      break;

    case 8:
      step = (<TutorialStep8/>);
      break;

    case 9:
      step = (<TutorialStep9/>);
      break;
      
    default:
      step = null;
  }

  return (
    <div className="c-tutorial-container">
      {step}
    </div>
  );
};

const TutorialManager = connect(mapStateToProps)(connectedTutorialManager);

export default TutorialManager;


// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialManager.js